module.exports = __webpack_public_path__ + "img/wlv_18.2aeef14c.png";